import { Mail } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { ApiError } from '@/api/client'
import type { User } from '@/api/types'
import { useToast } from '@/components/ui/Toast'
import { useT } from '@/i18n'

import { useStartConversation } from '../hooks/useMessages'
import { cannotStartMessage } from '../reasons'

/** 用户页上的「私信」按钮。只在 `viewer.can_message` 时出现（D70）。 */
export function MessageButton({ user }: { user: User }) {
  const t = useT()
  const navigate = useNavigate()
  const toast = useToast()
  const start = useStartConversation()

  if (!user.viewer?.can_message) return null

  return (
    <button
      type="button"
      onClick={() =>
        start.mutate(user.username, {
          onSuccess: (conversation) => navigate(`/messages/${conversation.id}`),
          onError: (error) =>
            toast.error(
              error instanceof ApiError ? cannotStartMessage(error, t) : t('toast.actionFailed'),
            ),
        })
      }
      disabled={start.isPending}
      aria-label={t('messages.messageUser', { username: user.username })}
      className="flex size-9 items-center justify-center bg-surface-subtle text-ink px-corners hover:bg-line disabled:opacity-60"
    >
      <Mail className="size-5" />
    </button>
  )
}
